const getters = {
  dictFromCode: state => code =>
      state.dictionaryList.filter(item => item.dictCode == code),
  allDictionary(state) {
    return state.dictionaryList;
  }, 

  //省市
  searchAdd: state => value => {
    let obj = state.addrList.filter(item => item.id === value);
    return obj.length ? obj[0].name : null;
  },

  //性别
  GENDER(state) {
    let obj = state.dictionaryList.filter(item => item.dictCode === "GENDER");
    return obj;
  },
  //政治面貌
  POLITICAL_STATUS(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "POLITICAL_STATUS"
    );
    return obj;
  },
  //工作性质
  WORK_NATURE(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "WORK_NATURE"
    );
    return obj;
  },
  //工作性质
  GROUP_TYPE(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "GROUP_TYPE"
    );
    return obj;
  },
  //学历
  EDUCATION(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "EDUCATION"
    );
    return obj;
  },

  //学位
  DEGREE(state) {
    let obj = state.dictionaryList.filter(item => item.dictCode === "DEGREE");
    return obj;
  },
  //证件类别
  ID_TYPE(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "ID_TYPE"
    );
    return obj;
  },
  //民族
  NATIONALITY(state) {
    let obj = state.dictionaryList.filter(
      item => item.dictCode === "NATIONALITY"
    );
    return obj;
  },
  //会员类型
  getMemberType: state => memberType => {
    var obj = state.memberTypeList.filter(function(item) {
      return item.memberType === memberType;
    });

    if (!obj.length) return "网员";
    return obj[0].memberTypeText;
  },
  commond: state => (type, val) => {
    if (!state.dictionary) return;
    //兼容特殊情况
    if (type == 2 && state.customize == 1) {
      type = 34;
    }

    var educationList = state.dictionary.filter(function(item) {
      return item.dictionaryId == type;
    });

    var obj = educationList.filter(function(item) {
      return item.value === val;
    });

    if (!obj.length) return;
    return obj[0].name;
  },
  //是否是团体会员
  isGroupMember: state => {
    return state.userInfo && state.userInfo.memberCategory === 2;
  },
};

export default getters;